import { render, staticRenderFns } from "./InspectionFormRemindersList.vue?vue&type=template&id=59dede27"
import script from "./InspectionFormRemindersList.vue?vue&type=script&lang=js"
export * from "./InspectionFormRemindersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports